<div class="messenger-image">
  <img [src]="this.imageUrl" alt="" />
</div>
